<!-- 下拉选择器组件分装 -->
<template>
  <div>
    <el-upload ref="upload" action="" :file-list="listPicUrls" :before-upload="beforeUpload"
					list-type="picture-card" accept="mage/jpg,image/jpeg,image/png">
					<i slot="default" class="el-icon-plus"></i>
					<div slot="file" slot-scope="{file}">
						<img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
						<span class="el-upload-list__item-actions">
							<span class="el-upload-list__item-preview" title="放大"
								@click="handlePictureCardPreview(file)">
								<i class="el-icon-zoom-in"></i>
							</span>
							<span class="el-upload-list__item-delete" title="删除" @click="handlePictureRemove(file)">
								<i class="el-icon-delete"></i>
							</span>
						</span>
					</div>
				</el-upload>
				<el-dialog :visible.sync="dialogPicVisible" append-to-body>
					<el-image style="max-width: 100%; height: auto;" :src="dialogImageUrl"
						:fit="scale - down"></el-image>
				</el-dialog>
  </div>
</template>
  
<script>
export default {
  name: "upload-batch",
  props: ["urls"],
  data() {
    return {
      listPicUrls:"",
      dialogPicVisible:false,
      dialogImageUrl:'',
    }
  },
  watch: {
    urls: {
      handler(newValue) {
        this.listPicUrls=newValue
      },
      deep: true,
      immediate: true
    },
  },
  methods: {
    handleCallBack() {
      this.$emit("callBack", this.listPicUrls);
    },
   //预览图片时
		handlePictureCardPreview(file) {
			this.dialogImageUrl = file.url
			this.dialogPicVisible = true
		},
		//删除图片时
		handlePictureRemove(file, fileList) {
			let index = this.listPicUrls.findIndex(item => item.picUrl == file.picUrl);
			if (index != -1) {
				this.listPicUrls.splice(index, 1);
			}
      this.handleCallBack();
		},
		beforeUpload(file) {
			if (!this.checkUploadPic(file)) {
				return false;
			}
			let formData = new FormData();
			formData.append('file', file);//传文件
			this.$axios.post('/comm/uploadfile', formData).then(res => {
				if (res.data.status == 0) {
					this.listPicUrls.push(
						{
							"id": 0, "url": res.data.data.showUrl, "picUrl": res.data.data.dbPath
						}
					);
          this.handleCallBack()
				}
				else {
					this.$message(res.data.msg);
				}
			})
			return false;
		},
  },
}
</script>
  
<style scoped lang="scss">

</style>
  
  